module.exports = __webpack_public_path__ + "static/media/23.cd154953.jpeg";